import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Switch } from '../design/switch';
import { SunIcon, MoonIcon } from '@heroicons/react/20/solid';

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div className="flex items-center space-x-3">
        {theme === 'light' ? (
          <SunIcon className="w-5 h-5 text-amber-500" />
        ) : (
          <MoonIcon className="w-5 h-5 text-blue-400" />
        )}
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {theme === 'light' ? 'Light Mode' : 'Dark Mode'}
        </span>
      </div>
      <Switch
        checked={theme === 'dark'}
        onChange={toggleTheme}
        color="blue"
      />
    </div>
  );
};

export default ThemeToggle;





